//Generated File 
export const Commit = `Commit`;
export const Disabled = `Disabled`;
export const EditAfterCommit = `EditAfterCommit`;
export const SaveDraft = `SaveDraft`;
